import { useEffect, useState } from 'react';

/**
 * 値が変わってから delayMs のあいだ次の変化が無ければ、その値を返す（打つたびに検索を投げないため）。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 入力が落ち着くまで値の反映を待ち、打つたびに問い合わせを投げないようにする
 * @graph-connects none
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);
  return debounced;
}
